module.exports = __webpack_public_path__ + "static/img/banner.6b85d2f2.png";